import { useParams } from 'react-router-dom'
import PageCalling from 'src/components/common/PageCalling'

import useAPI from 'src/hooks/useAPI'
import Footer from 'src/components/common/Footer'
import Banner from 'src/components/common/Banner'
import Terms from 'src/components/views/join/Terms'
import JoinSubmit from 'src/components/views/join/JoinSubmit'
import PhoneVerification from 'src/components/views/join/PhoneVerification'

import { useEffect } from 'react'
import {
  authKeyState,
  PartnerListData,
  TelTypeState,
  TermsListState,
  uiData,
} from 'src/recoil/common'
import { useRecoilState, useSetRecoilState } from 'recoil'
import useMoveScroll from 'src/hooks/useMoveScroll'
import { PramsKeys } from 'src/types/type'
import styled from 'styled-components'
import { MktFormWrap } from 'src/styles/styledcomponent/views/join/MktForm'
import useSubmit from 'src/hooks/useSubmit'
import MvnoModal from 'src/components/views/join/MvnoModal'
import { convertTermsData } from 'src/service/join'
import {landing_greenp} from "src/service/utils/greenp";
import {useTrackingPage} from "src/hooks/useTrackingPage";
import VulnerableCheckModal from 'src/components/views/join/VulnerableCheckModal'

const MktWrap = styled(MktFormWrap)``
const CommonLayout = styled.div`
  max-width: 430px;
  margin: 0 auto;
`

const Join = (): JSX.Element => {
  const { pcode, authKey, telecom } = useParams<PramsKeys>()
  const api = useAPI('requestTermsList')
  const submit = useSubmit(pcode ?? '')
  const { data: getTermsData, isSuccess, isLoading } = api?.useSetQuery({ PCode: pcode })
  const setAuthKey = useSetRecoilState(authKeyState)
  const setTermsListState = useSetRecoilState(TermsListState)
  const setPartnerData = useSetRecoilState(PartnerListData)
  const [{ layoutsInsert: { mainBg }}, setUiData] = useRecoilState(uiData)
  const setTelType = useSetRecoilState(TelTypeState)
  const { RefElement, onMoveToElement, RefInput } = useMoveScroll()
  const { form, isGreenpTracking } = useTrackingPage()
  const isErrorPartner = getTermsData?.Header.ErrCode === 1011

  //Greenp 추적 스크립트 추가(251217)
  useEffect(() => {
    if (!isGreenpTracking) return
    if ((window as any).__GREENP_LANDING_INIT__) return
      ;(window as any).__GREENP_LANDING_INIT__ = true
    landing_greenp()
  }, [form, isGreenpTracking])

  useEffect(() => {
    switch (isSuccess) {
      case pcode === 'pinc_01':
        return setAuthKey(authKey)
      default:
    }
  }, [isSuccess, authKey, pcode, setAuthKey])

  useEffect(() => {
    if (isSuccess && !isErrorPartner) {
      const data = getTermsData?.Body
      setTelType(Number(telecom))
      setTermsListState(convertTermsData(data))
      setPartnerData(data?.Partner)
      setUiData(JSON.parse(atob(getTermsData.Body?.Partner.UiData)))
    }
    // eslint-disable-next-line
  }, [isSuccess, isErrorPartner, getTermsData?.Body, setPartnerData, setTermsListState, setTelType, setUiData])


  return (
    <CommonLayout>
      <PageCalling active={isLoading} />
      { isSuccess && (
        <MktWrap mainBg={mainBg}>
          <Banner RefElement={RefElement} />
          <PhoneVerification onMoveToElement={onMoveToElement} RefInput={RefInput} submit={submit} />
          {!isErrorPartner && <Terms data={getTermsData?.Body?.Terms} />}
          <JoinSubmit submit={submit} />
          <Footer />
          <MvnoModal submit={submit} />
          <VulnerableCheckModal submit={submit} />
        </MktWrap>
      )}
    </CommonLayout>
  )
}
export default Join
